import React from 'react';
import { observer } from 'mobx-react';
import { OEToggle } from '../../global/oe-toggle/oe-toggle';
import Text from '../../global/text/text';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import { ThirdPartyRegistrationFormVM } from './third-party-registration-form.viewmodel';
import { THIRDRD_PARTY_EVENT_REGISTRATION_STATUS_TEXT } from '../account-admin.text';
import { AccountAdminSettingFormFooter } from '../common/account-admin-setting-form-footer';

interface IThirdPartyRegistrationFormPresentationProps {
    vm: ThirdPartyRegistrationFormVM;
}

const ThirdPartyRegistrationFormPresentation = observer((props: IThirdPartyRegistrationFormPresentationProps): JSX.Element => {
    const { vm } = props;
    const { settingsEntity } = vm;

    return (
        <CommonPopupBodyFooterLayout
            body={
                <>
                    <div className='oe-form'>
                        <div className='oe-form__body'>
                            <div className='m-top-10px m-bottom-0px flex center'>
                                <OEToggle
                                    isSelected={settingsEntity.enabled}
                                    onClick={settingsEntity.toggleEnabled}
                                    dataTestId='toggle-third-party-registration'
                                />
                                <Text
                                    {...THIRDRD_PARTY_EVENT_REGISTRATION_STATUS_TEXT}
                                    values={{
                                        suffix: settingsEntity.suffix
                                    }}
                                    className='line-height-25px'
                                />
                            </div>
                        </div>
                    </div>
                </>
            }
            footer={
                <AccountAdminSettingFormFooter
                    handleClose={vm.handleClose}
                    handleSubmit={vm.handleSubmit}
                    isDisabled={vm.saving}
                />
            }
        />
    );
});

export { ThirdPartyRegistrationFormPresentation };
